import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

import ImageZoom from "js-image-zoom";
import MetaComponent from "../../components/MetaComponent";
import { useParams } from "react-router-dom";
import { useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Tooltip from '@mui/material/Tooltip';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ShareTwoToneIcon from '@mui/icons-material/ShareTwoTone';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';
import dayjs from 'dayjs'

// collapse
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Collapse from '@mui/material/Collapse';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import InboxIcon from '@mui/icons-material/MoveToInbox';
import StyleTwoToneIcon from '@mui/icons-material/StyleTwoTone';
import AutoFixHighTwoToneIcon from '@mui/icons-material/AutoFixHighTwoTone';
import AssessmentTwoToneIcon from '@mui/icons-material/AssessmentTwoTone';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import SourceTwoToneIcon from '@mui/icons-material/SourceTwoTone';
import SkipNextTwoToneIcon from '@mui/icons-material/SkipNextTwoTone';
import SkipPreviousTwoToneIcon from '@mui/icons-material/SkipPreviousTwoTone';
import ZoomInTwoToneIcon from '@mui/icons-material/ZoomInTwoTone';
import ZoomOutTwoToneIcon from '@mui/icons-material/ZoomOutTwoTone';
import ZoomInMapTwoToneIcon from '@mui/icons-material/ZoomInMapTwoTone';
import ZoomOutMapTwoToneIcon from '@mui/icons-material/ZoomOutMapTwoTone';

// swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/autoplay';
import 'swiper/css/scrollbar';

import './../assets/styles.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Scrollbar, Autoplay } from 'swiper/modules';
import { FreeMode, Thumbs } from 'swiper/modules';

import DownloadTwoToneIcon from '@mui/icons-material/DownloadTwoTone';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

// ----------- INI pdf

import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const config = require("../../constants/constants.js")

const urlpdffile = config.URL_IMAGES_CUSTOMER1 + "menucerimonie.pdf";

// ----------- FIN pdf

const { strCurrency, strEuroCurrency } = require('../../utils/currencyUtils.js')

const size_linkToAllServices = 40;

const ProductDetailsPageComponent = ({
  addToCartReduxAction,
  reduxDispatch,
  getProductDetails,
  userInfo,
  writeReviewApiRequest
}) => {

  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [showCartMessage, setShowCartMessage] = useState(false);
  const [product, setProduct] = useState([]);
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [collapses, setCollapses] = useState([]);
  const [noteCollapses, setNoteCollapses] = useState([]);
  const [pathPdfsToDwn, setPathPdfsToDwn] = useState("");
  const [namePdfsToDwn, setNamePdfsToDwn] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [productReviewed, setProductReviewed] = useState(false);
  const [linkHttpButtonName, setLinkHttpButtonName] = useState("");
  const [linkHttpButtonHelp, setLinkHttpButtonHelp] = useState("");
  const [linkHttpPath, setLinkHttpPath] = useState("");

  const [showlinkHttp, setShowlinkHttp] = useState("No");

  let navigate = useNavigate();

  const url_elencoServizi = "/prodotti";
  const url_image_elencoProdotti = config.URL_IMAGES_CUSTOMER1 + "elenco-prodotti.png";
  const help_image_elencoProdotti = "elenco dei prodotti";

  const [showAlertLogin, setShowAlertLogin] = useState(false);

  const messagesEndRef = useRef(null);

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  //const pdfname = "/menucerimonieh.pdf#toolbar=0&navpanes=0"
  //  const pdfname = "/menucerimonieh.pdf#toolbar=0"
  const pdfname = "./menucerimonieh.pdf"
  const pdfname1 = "/menucerimonieh.pdf"

  // --- INI collapse

  const [openCollapse0, setOpenCollapse0] = React.useState(false);
  const [openCollapse1, setOpenCollapse1] = React.useState(false);
  const [openCollapse2, setOpenCollapse2] = React.useState(false);
  const [openCollapse3, setOpenCollapse3] = React.useState(false);

  const expandTF = (num) => {
    if (num === 0 && openCollapse0) { return true }
    if (num === 1 && openCollapse1) { return true }
    if (num === 2 && openCollapse2) { return true }
    if (num === 3 && openCollapse3) { return true }
    return false
  }

  const handleClickCollapse = (num) => {
    console.log("[handleClickCollapse] nums =", num);
    if (num === 0) setOpenCollapse0(!openCollapse0);
    if (num === 1) {
      setOpenCollapse1(!openCollapse1);
      //console.log("[set collapse 1 num =", num);
    }
    if (num === 2) setOpenCollapse2(!openCollapse2);
    if (num === 3) setOpenCollapse3(!openCollapse3);
  };

  // --- END collapse


  const addToCartHandler = (e) => {
    reduxDispatch(addToCartReduxAction(id, quantity));
    setShowCartMessage(true);
  };

  useEffect(() => {
    if (productReviewed) {
      setTimeout(() => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }, 200)
    }
  }, [productReviewed])

  useEffect(() => {
    if (product.images) {
      var options = {
        // width: 400,
        // zoomWidth: 500,
        // fillContainer: true,
        // zoomPosition: "bottom",
        scale: 2,
        offset: { vertical: 0, horizontal: 0 },
      };

      product.images.map(
        (image, id) =>
          new ImageZoom(document.getElementById(`imageId${id + 1}`), options)
      );
    }
  });

  useEffect(() => {
    getProductDetails(id)
      .then((data) => {
        setProduct(data);
        console.log("[useEffect] data =", data);
        //console.log("[useEffect] path =", data?.linkHttp.path);
        setImages(data?.images);
        setPdfs(data?.pdfs);
        setCollapses(data?.collapses);
        setNoteCollapses(data?.noteCollapses);
        setPathPdfsToDwn(data?.pdfs[0].path);
        setNamePdfsToDwn(data?.pdfs[0].name);
        if (data?.linkHttp && typeof data?.linkHttp.buttonName !== 'undefined') {
          setShowlinkHttp("Si");
          setLinkHttpButtonName(data?.linkHttp.buttonName);
          setLinkHttpButtonHelp(data?.linkHttp.buttonHelp);
          setLinkHttpPath(data?.linkHttp.path);
        }
        setLoading(false);
        //console.log("[useEffect] data?.linkHttp.buttonName =", data?.linkHttp.buttonName);
        //console.log("[useEffect] images =", data.images);
        //console.log("[useEffect] pdfs =", data.pdfs);
        //console.log("[useEffect] pathPdfsToDwn =", data?.pdfs[0].path);
        //console.log("[useEffect] collapses =", data.collapses);
        //console.log("[useEffect] noteCollapses =", data?.noteCollapses);
      })
      .catch((er) =>
        setError(
          er.response.data.message ? er.response.data.message : er.response.data
        )
      );
  }, [id, productReviewed]);

  const routeChange = () => {
    //e.preventDefault();
    navigate(url_elencoServizi);
  }

  function verificaTrue(value) {
    if (value === true) {
      return "true";
    } else return "false";
  }

  function verificaContieneCaratteri(value) {
    console.log("[verificaMaggioveDiZero] value =", (value === ""))
    if (value === "") {
      return "true";
    } else return "";
  }

  //  const Item = styled(Paper)(({ theme }) => ({
  //    backgroundColor: '#b6d6e0ff',
  const Item = styled(Box)(({ theme }) => ({
    backgroundColor: '#bfdae3ff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: (theme.vars ?? theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

  const goBack = () => {
    navigate(-1);
  }

  // --- INI -------  Confirm Dialog
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const PopupConfirmConfirm = async () => {
    console.log('[PopupConfirmConfirm]')
    setOpen(false);
    window.location.assign('/admin/categories')
  };

  const PopupConfirmClose = () => {
    console.log('[PopupConfirmClose]')
    setOpen(false);
  };

  const ViewConfirmDialog = () => {
    return (
      <Dialog
        open={open}
        onClose={PopupConfirmClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ background: "#4bf5cc", fontWeight: "bold" }}>
          {"Cancellazione tipo prodotto"}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description" >
            &nbsp;
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" >
            Confermi il    <b><i>tipo prodotto</i></b> ?
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" >
            &nbsp;
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            size="small"
            color="warning"
            onClick={PopupConfirmClose}>
            Annulla
          </Button>
          <Button
            variant="contained"
            size="small"
            color="success"
            onClick={PopupConfirmConfirm}
            autoFocus
          >
            Conferma
          </Button>
        </DialogActions>

      </Dialog>
    );
  };
  // --- FIN -------  Confirm Dialog

  const [applicativo, setApplicativo] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [email, setEmail] = useState("");
  const [telefonoCallFromSite, setTelefonoCallFromSite] = useState("");
  const [linkWhatsapp, setLinkWhatsapp] = useState("");
  const [linkFacebook, setLinkFacebook] = useState("");
  const [linkInstagram, setLinkInstagram] = useState("");
  const [linkTwitter, setLinkTwitter] = useState("");
  const [linkLinkedin, setLinkLinkedin] = useState("");
  const [urlSiteImageServer, setUrlSiteImageServer] = useState("");
  const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");

  const [showPriceProducts, setShowPriceProducts] = useState("");
  const [showPriceServices, setShowPriceServices] = useState("");
  const [showPriceEvents, setShowPriceEvents] = useState("");
  const [showSectionAddCardProducts, setShowSectionAddCardProducts] = useState("");
  const [showSectionAddCardServices, setShowSectionAddCardServices] = useState("");
  const [showSectionAddCardEvents, setShowSectionAddCardEvents] = useState("");
  const [showSectionCollapseProducts, setShowSectionCollapseProducts] = useState("");
  const [showSectionCollapseServices, setShowSectionCollapseServices] = useState("");
  const [showSectionCollapseEvents, setShowSectionCollapseEvents] = useState("");
  const [showReviews, setShowReviews] = useState("");

  const [showCatalogDownloadInDetailsPage, setShowCatalogDownloadInDetailsPage] = useState("");

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      //console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setRagioneSociale(data?.ragioneSociale);
      setEmail(data?.email);
      setTelefonoCallFromSite("tel:" + data?.telefonoCallFromSite)
      setLinkWhatsapp("https://wa.me/" + data?.linkWhatsapp);
      setLinkFacebook(data?.linkFacebook);
      setLinkInstagram(data?.linkInstagram);
      setLinkTwitter(data?.linkTwitter);
      setLinkLinkedin(data?.linkLinkedin);
      setUrlSiteImageServer(data?.urlSiteImageServer);
      setUrlCustomerImageServer(data?.urlCustomerImageServer);
      //setIsShopActive(data?.isShopActive === "Si" ? true : false);
      //setIsIconLoginActive(data?.isIconLoginActive === "Si" ? true : false);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      setShowPriceProducts(data?.showPriceProducts);
      setShowPriceServices(data?.showPriceServices);
      setShowSectionAddCardProducts(data?.showSectionAddCardProducts);
      setShowSectionCollapseProducts(data?.showSectionCollapseProducts)
      setShowPriceEvents(data?.showPriceEvents);
      setShowCatalogDownloadInDetailsPage(data?.showCatalogDownloadInDetailsPage);
      setShowReviews(data?.showReviews);
      //console.log(`data?.applicativo =`, data?.applicativo);
      //console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      //console.log(`data?.linkFacebook =`, data?.linkFacebook);
      //console.log(`data?.linkInstagram =`, data?.linkInstagram);
      //console.log(`data?.linkTwitter =`, data?.linkTwitter);
      //console.log(`ragioneSociale =`, data?.ragioneSociale);
      //console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
      //console.log(`isShopActive =`, data?.isShopActive);
      //console.log(`isIconLoginActive =`, data?.isIconLoginActive);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [ragioneSociale, setEmail, setUrlCustomerImageServer])

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // ----------  INI pdf

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(0.4);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () => setPageNumber((prev) => (numPages ? Math.min(prev + 1, numPages) : prev));

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.20, 3));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.20, 0.40));
  const resetZoom = () => setScale(0.4);

  const openPdfInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // ----------  FIN pdf

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid
        container
        size={{ xs: 12, md: 12 }}
        paddingTop={{ xs: 0, md: 0 }}
        paddingLeft={{ xs: 0, md: 0 }}
        paddingRight={{ xs: 0, md: 0 }}
        spacing={{ xs: 0, md: 0 }}
        sx={{
          // background: '#242424',   // sfondo mainMenu = nero 
          background: '#2074d4'       // sfondo mainMenu = blu navy
        }}
      >
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          size={{ xs: 12, md: 4 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 8, md: 17 }}   // per posizione dopo logo di sx
          paddingRight={{ xs: 1, md: 0 }}
          spacing={{ xs: 0, md: 0 }}
          color="white"
          fontFamily="sans-serif"
          textTransform='none'
          fontSize={14}
        >
          <Link underline="hover" color="inherit" href="/">
            <HomeOutlinedIcon />
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/prodotti"
          >
            {config.BC_PRODOTTI}
          </Link>
          <Typography
            sx={{
              color: 'white',
              fontFamily: "sans-serif",
              textTransform: 'none',
              fontSize: 14,
            }}
          >
            {product.name}
          </Typography>

        </Breadcrumbs>
      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: { xs: 0, md: 5 }
        }}
      />

      <Grid container spacing={{ xs: 2, md: 6 }}
      >
        <Grid
          size={{ xs: 0, md: 0.1 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingBottom={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 0, md: 0 }}
          paddingRight={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 3.8 }}
          paddingTop={{ xs: 0, md: 2 }}
          paddingBottom={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 0, md: 0 }}
          paddingRight={{ xs: 0, md: 0 }}
          style={{ zIndex: 1 }}
        >

          <Dialog open={open}>
            <Alert
              variant="filled"
              severity="info"
              onClose={() => { setOpen(false) }}
            >

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 20
                }}
              />

              <Typography variant="body1"
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 16,
                  color: 'text.secondary',
                }}
              >
                Il prodotto è stato aggiunto al carrello
              </Typography>

              <Stack
                sx={{
                  paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  display: 'flex',
                  flexDirection: { xs: "row", md: "row" },
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >

                <Button
                  type="button"
                  variant="contained"
                  color="warning"
                  onClick={(e) => { goBack(e); }}
                  sx={{
                    width: "12ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                >
                  Acquisti
                </Button>

                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  onClick={() => { navigate("/cart") }}
                  sx={{
                    width: "22ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                >
                  Vai al carrello
                </Button>
              </Stack>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 20
                }}
              />

            </Alert>
          </Dialog>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
            }}
          >

            <Paper
              sx={{
                paddingTop: 1, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                background: 'rgba(237, 242, 243, 0.61)',
              }}
              elevation={6}
            >

              <Swiper
                pagination={{
                  type: 'fraction',
                  clickable: true,
                }}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs, Pagination]}
                className="mySwiper2"
              >

                {images.map((slide, idx) =>

                  <div key={idx}>

                    {console.log("images=", images)}

                    <SwiperSlide>

                      {slide.path.indexOf('.pdf') > 0 ?

                        <>

                          {console.log("slide.path=", slide.path)}

                          <Grid
                            container
                            size={{ xs: 12, md: 12 }}
                            paddingTop={{ xs: 0, md: 0 }}
                            paddingLeft={{ xs: 0, md: 0 }}
                            paddingRight={{ xs: 0, md: 0 }}
                            spacing={{ xs: 0, md: 0 }}
                            sx={{
                              // background: '#242424',   // sfondo mainMenu = nero 
                              background: '#757677'       // sfondo mainMenu = blu navy
                            }}
                            //width={380}
                            height={380}
                          >

                            <nav style={{ display: "flex", gap: "8px", alignItems: "center" }}>

                              <IconButton
                                onClick={goToPrevPage}
                                disabled={pageNumber <= 1}
                                sx={{
                                  p: { xs: 0, md: 0 },
                                  m: { xs: 1, md: 1 },
                                  backgroundColor: "#f4f7f5",
                                }}
                              >
                                <SkipPreviousTwoToneIcon />
                              </IconButton>

                              <span>
                                <Typography
                                  sx={{
                                    color: 'white',
                                    fontFamily: "sans-serif",
                                    fontSize: 12,
                                  }}
                                >
                                  pagina {pageNumber} di {numPages}
                                </Typography>
                              </span>

                              <IconButton
                                onClick={goToNextPage}
                                disabled={!numPages || pageNumber >= numPages}
                                sx={{
                                  p: { xs: 0, md: 0 },
                                  m: { xs: 0, md: 1 },
                                  backgroundColor: "#f4f7f5",
                                }}
                              >
                                <SkipNextTwoToneIcon />
                              </IconButton>

                              <IconButton
                                onClick={zoomOut}
                                disabled={scale <= 0.40}
                                sx={{
                                  p: { xs: 0, md: 0 },
                                  m: { xs: 0, md: 1 },
                                  backgroundColor: "#f4f7f5",
                                }}
                              >
                                < ZoomOutTwoToneIcon />
                              </IconButton>

                              <span>
                                <Typography
                                  sx={{
                                    color: 'white',
                                    fontFamily: "sans-serif",
                                    fontSize: 12,
                                  }}
                                >
                                  {Math.round(scale * 100)}%
                                </Typography>
                              </span>

                              <IconButton
                                onClick={zoomIn}
                                disabled={scale >= 3}
                                sx={{
                                  p: { xs: 0, md: 0 },
                                  m: { xs: 0, md: 1 },
                                  backgroundColor: "#f4f7f5",
                                }}
                              >
                                < ZoomInTwoToneIcon />
                              </IconButton>

                              <IconButton
                                onClick={resetZoom}
                                sx={{
                                  p: { xs: 0, md: 0 },
                                  m: { xs: 0, md: 1 },
                                  backgroundColor: "#f4f7f5",
                                }}
                              >
                                < ZoomInMapTwoToneIcon />
                              </IconButton>

                              <IconButton
                                onClick={() => openPdfInNewTab(slide.path)}
                                sx={{
                                  p: { xs: 0, md: 0 },
                                  m: { xs: 0, md: 1 },
                                  backgroundColor: "#f4f7f5",
                                }}
                              >
                                < ZoomOutMapTwoToneIcon />
                              </IconButton>

                            </nav>

                            <Stack
                              sx={{
                                //flexDirection: { xs: "row", md: "row" },
                                paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 2,
                                position: "center", overflowX: "scroll", overflowY: "scroll",
                                '@media (min-width: 600px)': { width: '430px', height: '380px', },
                                '!@media (min-width: 600px)': { width: '430px', height: '380px', },
                              }}
                            >
                              <Document file={slide.path} onLoadSuccess={onDocumentLoadSuccess} scale={0.5} >
                                <Page pageNumber={pageNumber} scale={scale} />
                              </Document>
                            </Stack>
                          </Grid>
                        </>

                        :
                        <img src={slide.path} />

                      }

                      <div class="text-overlay" hidden={verificaContieneCaratteri(slide.title)}>

                        <Stack
                          sx={{
                            flexDirection: { xs: "column", md: "column" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 18,
                              color: '#ffffff',
                            }}
                          >
                            {slide.title}
                          </Typography>
                          <Typography
                            sx={{
                              //paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                              //p: 0, m: 0,
                              fontFamily: 'Arial',
                              fontWeight: 300,
                              fontSize: 14,
                              color: '#ffffff',
                            }}
                          >
                            {slide.subTitle}
                          </Typography>

                        </Stack>
                      </div>
                      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </SwiperSlide>

                  </div>

                )}

              </Swiper>

              <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={5}
                slidesPerView={5}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs, Pagination]}
                className="mySwiper"
              >
                {images.map((slide, idx) =>

                  <div key={idx}>

                    {console.log("images=", images)}

                    <SwiperSlide title={slide.title} >

                      {slide.path.indexOf('.pdf') > 0 ?
                        <img src="/images-0001/pdf-generico.jpg" />
                        :
                        <img src={slide.path} />
                      }

                    </SwiperSlide>

                  </div>
                )}
              </Swiper>

            </Paper>

          </Box>

        </Grid>

        <Grid
          size={{ xs: 12, md: 5.0 }}
          sx={{
            paddingTop: 2, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
          }}
        >

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Stack
              spacing={0}
              sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: 1, paddingLeft: 3, paddingRight: 0, }}
            >

              <Grid container spacing={2}
                sx={{
                  paddingTop: 0,
                }}
              >

                <Grid size={{ xs: 12, md: 12 }}>

                  <Grid container spacing={2}
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,

                    }}
                  >
                    <Grid size={{ xs: 8.5, md: 8.5 }}>
                      <Typography variant="body1"
                        sx={{
                          fontFamily: 'Arial',
                          fontWeight: 700,
                          fontSize: 30,
                          color: 'text.primary',
                          paddingTop: 1
                        }}
                      >
                        {product.name}
                      </Typography>
                    </Grid>

                    <Grid
                      size={{ xs: 3.5, md: 3.5 }}
                      container
                      padding={1}
                      spacing={1}
                      justifyContent={"flex-end"}
                    >
                      <Typography variant="body2"
                        sx={{
                          paddingTop: 3, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          color: '#2033e5',
                          fontSize: 16,
                        }}
                      >
                        Prezzo <b>{strEuroCurrency(product.price)}</b>
                      </Typography>

                    </Grid>

                  </Grid>

                  <Typography variant="body2"
                    sx={{
                      color: 'text.secondary',
                      fontSize: 20,
                      paddingTop: 1
                    }}
                  >
                    {product.description}
                  </Typography>

                  <Typography variant="body2"
                    sx={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'italic',
                      fontWeight: 300,
                      color: 'text.secondary',
                      fontSize: 12,
                      paddingTop: 2,
                      paddingRight: 3,
                    }}
                  >
                    {product.note}
                  </Typography>


                  <Box
                    //display={showSectionAddCardProducts === 'Si' ? "block" : "none"}
                    sx={{ '& > :not(style)': { m: 1, paddingTop: { xs: 0, md: 0 } }, paddingLeft: { xs: 4, md: 0 }, paddingRight: { xs: 2, md: 2 } }}
                    noValidate
                    autoComplete="off"
                  >

                    <List
                      sx={{ width: '100%', bgcolor: '#bfdae3ff', color: '#294784' }}
                    >

                      {noteCollapses && noteCollapses.map((noteCollapse, idx) => (

                        <>

                          {noteCollapse.type === "elenco" &&
                            <List sx={{
                              listStyleType: 'disc',
                              paddingLeft: 6,
                            }}>
                              <ListItem
                                sx={{ display: 'list-item', paddingLeft: 0 }}
                              >
                                <Typography
                                  sx={{
                                    color: '#414141',
                                    fontFamily: 'Sans-Serif',
                                    fontWeight: 200,
                                    fontSize: 12,
                                    border: 0,
                                    padding: 0
                                  }}>
                                  {noteCollapse.elementText1}<br />
                                </Typography>
                              </ListItem>
                              <ListItem
                                sx={{ display: 'list-item', paddingLeft: 0 }}
                              >
                                <Typography
                                  sx={{
                                    color: '#383737',
                                    fontFamily: 'Sans-Serif',
                                    fontWeight: 200,
                                    fontSize: 12,
                                    border: 0,
                                    padding: 0
                                  }}>
                                  {noteCollapse.elementText2}<br />
                                </Typography>
                              </ListItem>
                              <ListItem
                                sx={{ display: 'list-item', paddingLeft: 0 }}
                              >
                                <Typography
                                  sx={{
                                    color: '#383737',
                                    fontFamily: 'Sans-Serif',
                                    fontWeight: 200,
                                    fontSize: 12,
                                    border: 0,
                                    padding: 0
                                  }}>
                                  {noteCollapse.elementText3}<br />
                                </Typography>
                              </ListItem>
                              <ListItem
                                sx={{ display: 'list-item', paddingLeft: 0 }}
                              >
                                <Typography
                                  sx={{
                                    color: '#383737',
                                    fontFamily: 'Sans-Serif',
                                    fontWeight: 200,
                                    fontSize: 12,
                                    border: 0,
                                    padding: 0
                                  }}>
                                  {noteCollapse.elementText4}<br />
                                </Typography>
                              </ListItem>
                            </List>
                          }

                        </>
                      ))}

                    </List>

                  </Box>

                </Grid>

              </Grid>

              <Grid container spacing={1}
                sx={{
                  paddingTop: 2,
                }}
              >

                <Grid size={{ xs: 12, md: 5 }}
                >
                  <Box
                    display={showCatalogDownloadInDetailsPage === 'Si' ? "block" : "none"}
                    sx={{ '& > :not(style)': { m: 0.2, width: '20ch' } }}
                  >

                    <Tooltip title="scarica il PDF" arrow placement="top">
                      <Button
                        type="button"
                        variant="contained"
                        color="success"
                        //size="small"
                        endIcon={<DownloadTwoToneIcon />}
                        sx={{
                          width: "20ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 1 },
                          //borderRadius: 35,
                          backgroundColor: "#21b6ae",
                        }}

                      >

                        <a href={pathPdfsToDwn} target="_blank" download={namePdfsToDwn}
                          style={{
                            color: "#FFFFFF",
                            textDecoration: "none"
                          }
                          }>
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={0}
                            my={0}                  >

                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                color: 'white',
                                fontFamily: 'Roboto',
                                textTransform: 'none',
                                fontSize: 16,
                              }}
                            >
                              menù
                            </Typography>
                          </Stack>
                        </a>
                      </Button>
                    </Tooltip>

                  </Box>

                </Grid>

                <Box display={showReviews === 'Si' ? "block" : "none"}>
                  <Grid size={3}>
                    <Item>
                      <Typography variant="body2"
                        sx={{
                          color: 'text.secondary',
                          paddingTop: 0,
                          fontSize: 14,
                        }}
                      >
                        <Rating
                          readOnly
                          size="small"
                          name="half-rating"
                          initialValue={product.rating}
                          precision={0.5}
                        />
                        ({product.reviewsNumber ? product.reviewsNumber : 0})
                      </Typography>
                    </Item>
                  </Grid>
                </Box>


                <Grid size={{ xs: 12, md: 5 }}>
                  <Box
                    display={showlinkHttp === 'Si' ? "block" : "none"}
                  >
                    <Box
                      sx={{ '& > :not(style)': { m: 0.2, width: '20ch' } }}
                    >

                      <Tooltip title="accedi al portale esempio" arrow placement="top">
                        <Button
                          type="button"
                          variant="contained"
                          color="success"
                          //size="small"
                          sx={{
                            width: "20ch",
                            p: { xs: 1, md: 1 },
                            m: { xs: 1, md: 1 },
                            //borderRadius: 35,
                            backgroundColor: "#21b6ae",
                          }}
                          endIcon={<ShareTwoToneIcon />}
                          onClick={() => openInNewTab(linkHttpPath)}
                        >

                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={0}
                            my={0}                  >

                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                color: 'white',
                                fontFamily: 'Roboto',
                                textTransform: 'none',
                                fontSize: 16,
                              }}
                            >
                              {linkHttpButtonName}
                            </Typography>
                          </Stack>
                        </Button>
                      </Tooltip>
                    </Box>
                    <Typography sx={{ color: '#1136a0', fontSize: 10, paddingBottom: 1 }}>
                      &nbsp; {linkHttpButtonHelp}
                    </Typography>
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                  <Item>
                    <Link to={url_elencoServizi}>
                      <Tooltip title={help_image_elencoProdotti} arrow placement="top">
                        <Box
                          component="img"
                          paddingTop={{ xs: 0, md: 0 }}
                          paddingLeft={{ xs: 0, md: 0 }}
                          sx={{
                            height: size_linkToAllServices,
                            width: size_linkToAllServices,
                            maxHeight: { xs: size_linkToAllServices, md: size_linkToAllServices },
                            maxWidth: { xs: size_linkToAllServices, md: size_linkToAllServices },
                          }}
                          src={url_image_elencoProdotti}
                          onClick={event => {
                            navigate(url_elencoServizi)
                          }}
                        >
                        </Box>
                      </Tooltip>
                    </Link>

                  </Item>
                </Grid>
              </Grid>

            </Stack>

          </Paper>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 30
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0.5, paddingLeft: 0, paddingRight: 0,
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Box
              display={showSectionAddCardProducts === 'Si' ? "block" : "none"}
              //sx={{ '& > :not(style)': { m: 1, width: '80ch', paddingTop: { xs: 0, md: 0 } }, paddingLeft: { xs: 4, md: 0 } }}
              noValidate
              autoComplete="off"
            >

              <Stack
                sx={{
                  flexDirection: { xs: "row", md: "row" },
                  paddingTop: 1, paddingLeft: 1, paddingRight: 0,
                  flexWrap: 'wrap'
                }}
              >

                <TextField id="id-name" label="Disponibile" variant="outlined" value={product.count > 0 ? "prenota" : "out of stock"}
                  size="small"
                  sx={{
                    width: "18ch",
                    minWidth: { xs: '18ch', md: '18ch' },
                    //p: 1,
                    m: 1,
                  }}
                  slotProps={{
                    input: { readOnly: true },
                    inputLabel: { shrink: true }
                  }}
                  onChange={(event) => {
                    //setName(event.target.value);
                  }}
                />

                <TextField id="id-name" label="Prezzo" variant="outlined" value={strEuroCurrency(product.price)}
                  size="small"
                  sx={{
                    width: "18ch",
                    minWidth: { xs: '18ch', md: '18ch' },
                    //p: 1,
                    m: 1,
                  }}

                  slotProps={{
                    input: { readOnly: true },
                    inputLabel: { shrink: true },
                  }}
                  onChange={(event) => {
                    //setName(event.target.value);
                  }}
                />

                <TextField id="id-quantity" label="Quantità" variant="outlined" value={quantity} type="number"
                  size="small"
                  sx={{
                    width: "10ch",
                    minWidth: { xs: '10ch', md: '10ch' },
                    //p: 1,
                    m: 1,
                  }}
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  InputProps={{
                    inputProps: {
                      max: 100, min: 0
                    }
                  }}
                  onChange={(event) => {
                    setQuantity(event.target.value);
                  }}
                />

                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  //size="small"
                  sx={{
                    width: "20ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                    //borderRadius: 35,
                    backgroundColor: "#148840",
                  }}
                  endIcon={<AddShoppingCartIcon />}
                  onClick={(e) => {
                    addToCartHandler(e);
                    handleClickOpen();
                  }}

                >

                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={0}
                    my={0}                  >

                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        color: 'white',
                        fontFamily: 'Roboto',
                        textTransform: 'none',
                        fontSize: 14,
                      }}
                    >
                      Aggiungi al carrello
                    </Typography>
                  </Stack>
                </Button>

              </Stack>

            </Box>

          </Paper>

        </Grid>


        {/*  -----------    Collapse  INI     -------------- */}

        <Grid
          size={{ xs: 10, md: 2.5 }}
          paddingTop={{ xs: 0, md: 2 }}
          paddingBottom={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 1, md: 1 }}
          paddingRight={{ xs: 1, md: 1 }}
        >

          <Paper
            sx={{
              paddingTop: 1, paddingBottom: 1, paddingLeft: 0, paddingRight: 0,
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Box
              display={showSectionCollapseProducts === 'Si' ? "block" : "none"}
              sx={{ '& > :not(style)': { m: 1, width: '30ch', paddingTop: { xs: 0, md: 0 } }, paddingLeft: { xs: 4, md: 0 } }}
              noValidate
              autoComplete="off"
            >

              <List
                sx={{ width: '100%', maxWidth: 360, bgcolor: '#bfdae3ff', color: '#294784' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >

                {collapses && collapses.map((collapse, idx) => (

                  <>

                    <ListItemButton
                      onClick={() => handleClickCollapse(idx)}
                    >
                      <ListItemIcon>
                        {collapse.iconName === "StyleTwoToneIcon" &&
                          <StyleTwoToneIcon />
                        }
                        {collapse.iconName === "CalendarMonthTwoToneIcon" &&
                          <CalendarMonthTwoToneIcon />
                        }
                        {collapse.iconName === "SourceTwoToneIcon" &&
                          <SourceTwoToneIcon />
                        }
                        {collapse.iconName === "AutoFixHighTwoToneIcon" &&
                          <AutoFixHighTwoToneIcon />
                        }
                      </ListItemIcon>
                      <ListItemText
                        disableTypography
                        primary={
                          <Typography
                            sx={{
                              fontFamily: 'Sans-Serif',
                              fontWeight: 400,
                              fontSize: 14,
                              color: '#1c1e85',
                            }}
                          >
                            {collapse.title}
                          </Typography>}
                      />

                      {expandTF(idx) ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse in={expandTF(idx)} timeout="auto" unmountOnExit>
                      {collapse.type === "immagine" &&
                        <>
                          <Box
                            component="img"
                            sx={{
                              height: 233,
                              width: 350,
                              maxHeight: { xs: 167, md: 167 },
                              maxWidth: { xs: 250, md: 250 },
                              border: 1,
                              borderColor: '#1c1e85',
                            }}
                            alt="The house from the offer."
                            src={collapse.imagePath}
                          />
                          <Typography
                            sx={{
                              color: '#414141',
                              fontFamily: 'Sans-Serif',
                              fontWeight: 200,
                              fontSize: 12,
                            }}>
                            <em>&nbsp;{collapse.imageTitle}</em>
                          </Typography>
                        </>
                      }
                      {collapse.type === "testo" &&
                        <>
                          <Typography
                            sx={{
                              color: '#414141',
                              fontFamily: 'Sans-Serif',
                              fontWeight: 200,
                              fontSize: 12,
                              border: 1,
                              borderColor: '#1c1e85',
                              padding: 0.5
                            }}>
                            {collapse.elementText1}<br />
                            {collapse.elementText2}<br />
                            {collapse.elementText3}<br />
                            {collapse.elementText4}
                          </Typography>
                        </>
                      }
                      {collapse.type === "elenco" &&
                        <List sx={{
                          listStyleType: 'disc',
                          paddingLeft: 6,
                        }}>
                          <ListItem
                            sx={{ display: 'list-item', paddingLeft: 0 }}
                          >
                            <Typography
                              sx={{
                                color: '#414141',
                                fontFamily: 'Sans-Serif',
                                fontWeight: 200,
                                fontSize: 12,
                                border: 0,
                                padding: 0
                              }}>
                              {collapse.elementText1}<br />
                            </Typography>
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingLeft: 0 }}
                          >
                            <Typography
                              sx={{
                                color: '#383737',
                                fontFamily: 'Sans-Serif',
                                fontWeight: 200,
                                fontSize: 12,
                                border: 0,
                                padding: 0
                              }}>
                              {collapse.elementText2}<br />
                            </Typography>
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingLeft: 0 }}
                          >
                            <Typography
                              sx={{
                                color: '#383737',
                                fontFamily: 'Sans-Serif',
                                fontWeight: 200,
                                fontSize: 12,
                                border: 0,
                                padding: 0
                              }}>
                              {collapse.elementText3}<br />
                            </Typography>
                          </ListItem>
                          <ListItem
                            sx={{ display: 'list-item', paddingLeft: 0 }}
                          >
                            <Typography
                              sx={{
                                color: '#383737',
                                fontFamily: 'Sans-Serif',
                                fontWeight: 200,
                                fontSize: 12,
                                border: 0,
                                padding: 0
                              }}>
                              {collapse.elementText4}<br />
                            </Typography>
                          </ListItem>
                        </List>
                      }
                    </Collapse>

                  </>
                ))}

              </List>

            </Box>
          </Paper>

        </Grid>

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

    </Box>
  );
};

export default ProductDetailsPageComponent;
